import { QueovalBase, QueovalDik } from '../global';

export class AdminConfigModel extends QueovalBase {
  public ConfigData: ConfigModelDB;
  public BoStagePropList: Array<PropBO>;
  public BoProductPropList: Array<PropBO>;
  public BoProspectPropList: Array<PropBO>;
  public BoClientPropList: Array<PropBO>;
  public BoClientProspectPropList: Array<PropBO>;
  public BoContactPropList: Array<PropBO>;
}

export class ConfigClient {
  public Name: string;
}

export class CData {
  public client: Array<CClient>;
}

export class CClient {
  public name: string;
  public stagefull: string;
  public stages: Array<CItem>;
  public products: Array<CItem>;
}

export class CItem {
  public optionalfields: Array<COptionalFields>;
}

export class COptionalFields {
  public fields: Array<CField>;
}

export class CField {
  public Value: string;
  public label: string;
}

export class PropBO {
  public Code_BOP: string;
  public Label: string;
  public Field: string;
  public Tooltip: string;
  public Group: string;
  public Mask: string;
}

export class ConfigModelDB {
  public Id: number;
  public ClientDB: string;
  public BlockFullStage: boolean;
  public RegistrationMode: ProcessMode;
  public ConfirmRegistrationByMail: boolean;
  public StageFields: Array<OptionalFieldDB>;
  public ProductFields: Array<OptionalFieldDB>;
  public StagePriceFields: Array<OptionalFieldDB>;
  public ProductPriceFields: Array<OptionalFieldDB>;
  public CustomLabels: Array<OptionalLabel>;
  public ProspectClientFields: Array<OptionalFieldDB>
  public ContactFields: Array<OptionalFieldDB>;
}

export class OptionalFieldDB {
  public Id: number;
  public ClientId: number;
  public Mode: string;
  public Field: string;
  public Label: string;
  public Mask: string;
  public Tooltip: string;
}

export class OptionalLabel {
  public TargetPage: string;
  public Key: string;
  public Label: Array<QueovalDik>;
}

export class OptionalForm {
  public Field: string;
  public Label: string;
  public Mask: string;
  public Tooltip: string;
  public Order: number;
  public Value: string;
}

export enum ProcessMode {
  BYMAIL,
  ONDB
}
